module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Tabs/images/overlay-active.0669b98c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Tabs/images/overlay-active.png
// module id = 2751
// module chunks = 11